/**
 * DI-2-4 — the data point's idempotency key.
 *
 *   externalId = uuidv5(INTAKE_NS, dataAcquisitionId + ':' + payloadSha256Hex)
 *
 * DETERMINISTIC per (acquisition, image): dropping the same folder again
 * replays every item, the server answers `created: 0`, and the page says
 * "527 already indexed — 0 new" (DI-D4 c4 — "a re-upload is a no-op by hash,
 * and the client is told so"; `08` §6.2 "reconcile by payload_hash" is then the
 * server's replay, not a client-side diff). The same image in another
 * acquisition gets another key — a data point is never shared (DI-D11).
 *
 * A file without a payload hash (no scan in the file — DI-2-1's M4T case) keys
 * on its whole-file MD5 instead, under a distinct prefix so the two spaces can
 * never collide. Its re-drop still replays; an EXIF rewrite would not (the MD5
 * changes), which is exactly why the payload hash is the normal key.
 */
import { INTAKE_NS, uuidV5 } from "../turbine/createAcquisition.js";

export function dataPointExternalId(
  dataAcquisitionId: string,
  hashes: { payloadSha256Hex: string | null; md5Hex: string },
): Promise<string> {
  const key = hashes.payloadSha256Hex ?? `md5:${hashes.md5Hex}`;
  return uuidV5(`${dataAcquisitionId}:${key}`, INTAKE_NS);
}
